"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionButtons = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionButtons = function ActionButtons(_ref) {
  var templateParameter = _ref.templateParameter,
      masked = _ref.masked,
      setMasked = _ref.setMasked;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.maskedActionButtons
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.showButton
  }, (templateParameter === null || templateParameter === void 0 ? void 0 : templateParameter.mask) && /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: _constants.secretListConstants.priVariant,
    onClick: function onClick() {
      return setMasked(!masked);
    }
  }, masked ? _constants.translatedStrings.showText : _constants.translatedStrings.hideText)));
};

exports.ActionButtons = ActionButtons;
ActionButtons.propTypes = {
  templateParameter: _propTypes.default.object,
  secretDetailData: _propTypes.default.object,
  masked: _propTypes.default.bool,
  setMasked: _propTypes.default.func
};